/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Storefront_Sold_OutInputs */

const en_storefront_sold_out = /** @type {(inputs: Storefront_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold Out`)
};

const es_storefront_sold_out = /** @type {(inputs: Storefront_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agotado`)
};

const fr_storefront_sold_out = /** @type {(inputs: Storefront_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Épuisé`)
};

const de_storefront_sold_out = /** @type {(inputs: Storefront_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausverkauft`)
};

const ja_storefront_sold_out = /** @type {(inputs: Storefront_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完売`)
};

const zh_storefront_sold_out = /** @type {(inputs: Storefront_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已售罄`)
};

const ar_storefront_sold_out = /** @type {(inputs: Storefront_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نفدت الكمية`)
};

const id_storefront_sold_out = /** @type {(inputs: Storefront_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habis Terjual`)
};

const it_storefront_sold_out = /** @type {(inputs: Storefront_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esaurito`)
};

const ru_storefront_sold_out = /** @type {(inputs: Storefront_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Распродано`)
};

const pt_storefront_sold_out = /** @type {(inputs: Storefront_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esgotado`)
};

const ko_storefront_sold_out = /** @type {(inputs: Storefront_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`품절`)
};

/**
* | output |
* | --- |
* | "Sold Out" |
*
* @param {Storefront_Sold_OutInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const storefront_sold_out = /** @type {((inputs?: Storefront_Sold_OutInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Storefront_Sold_OutInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_storefront_sold_out(inputs)
	if (locale === "es") return es_storefront_sold_out(inputs)
	if (locale === "fr") return fr_storefront_sold_out(inputs)
	if (locale === "de") return de_storefront_sold_out(inputs)
	if (locale === "ja") return ja_storefront_sold_out(inputs)
	if (locale === "zh") return zh_storefront_sold_out(inputs)
	if (locale === "ar") return ar_storefront_sold_out(inputs)
	if (locale === "id") return id_storefront_sold_out(inputs)
	if (locale === "it") return it_storefront_sold_out(inputs)
	if (locale === "ru") return ru_storefront_sold_out(inputs)
	if (locale === "pt") return pt_storefront_sold_out(inputs)
	return ko_storefront_sold_out(inputs)
});